import { Box, Group, Text, Badge, Button, ActionIcon } from '@mantine/core'
import { IconMap2, IconDoorExit, IconLayoutSidebarRightExpand, IconUsers, IconEye } from '@tabler/icons-react'
import { TextSizeControl } from '../game/TextSizeControl'

// Top strip across the full width: story name, thread position, team/solo badge,
// role badge, and utilities (story map, text size, exit). On mobile it also
// hosts the rail drawer toggle. In review mode it shows a "Reviewing" badge so
// the player knows this is a read-only walk-through of a completed story.
export function MissionBar({
  storyName,
  threadIndex,
  threadCount,
  threadTitle,
  isTeamPlay,
  teamName,
  roleName,
  reviewMode,
  onStoryMap,
  onExit,
  onToggleRail,
  showRailToggle,
}) {
  const position = typeof threadIndex === 'number' && threadCount
    ? `Thread ${threadIndex + 1} of ${threadCount}${threadTitle ? ` · ${threadTitle}` : ''}`
    : null

  return (
    <Box
      px="lg"
      py={8}
      style={{ borderBottom: '1px solid var(--bw-panel-border)', background: 'var(--bw-panel-bg)', flexShrink: 0 }}
    >
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
          <Text
            size="sm"
            fw={700}
            ff="var(--bw-heading-font)"
            style={{ color: 'var(--bw-accent)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {storyName || 'Loading…'}
          </Text>
          {position && (
            <Badge size="sm" variant="outline" color="gray" ff="var(--bw-heading-font)" style={{ flexShrink: 0 }}>
              {position}
            </Badge>
          )}
          {reviewMode && (
            <Badge
              size="sm"
              variant="light"
              color="cyan"
              ff="var(--bw-heading-font)"
              leftSection={<IconEye size={12} />}
              title="Read-only review of a completed story"
              style={{ flexShrink: 0 }}
            >
              Reviewing
            </Badge>
          )}
        </Group>

        <Group gap="xs" wrap="nowrap" style={{ flexShrink: 0 }}>
          {isTeamPlay ? (
            <Badge
              size="sm"
              variant="light"
              color="teal"
              ff="var(--bw-heading-font)"
              leftSection={<IconUsers size={12} />}
              title={`Playing as a team${teamName ? `: ${teamName}` : ''}`}
            >
              {teamName ? `Team · ${teamName}` : 'Team'}
            </Badge>
          ) : (
            <Badge size="sm" variant="outline" color="gray" ff="var(--bw-heading-font)" title="Solo play — just you">
              Solo
            </Badge>
          )}
          {roleName && (
            <Badge size="sm" variant="outline" color="violet" ff="var(--bw-heading-font)" title={`Your role: ${roleName}`}>
              {roleName}
            </Badge>
          )}
          {onStoryMap && (
            <Button size="xs" variant="subtle" color="gray" leftSection={<IconMap2 size={14} />} onClick={onStoryMap}>
              Story map
            </Button>
          )}
          <TextSizeControl />
          {showRailToggle && (
            <ActionIcon variant="subtle" color="gray" onClick={onToggleRail} aria-label="Open context rail">
              <IconLayoutSidebarRightExpand size={18} />
            </ActionIcon>
          )}
          {onExit && (
            <ActionIcon variant="subtle" color="gray" onClick={onExit} aria-label="Exit story">
              <IconDoorExit size={18} />
            </ActionIcon>
          )}
        </Group>
      </Group>
    </Box>
  )
}
